import { config } from "./config";
import store from './store'

export default {
    formatear_precio : value => {
        if (!value || value == 0) value = 0;
        const moneyFormatter = new Intl.NumberFormat(...config.CURRENCY);
        return moneyFormatter.format(value);
    },
    formatear_metodo_pago : value => {
        var metodos_de_pago_abonos_bases = store.getters.getTeatro.metodos_pago_abonos_bases_ventas;

        if (metodos_de_pago_abonos_bases && metodos_de_pago_abonos_bases.length > 0) {
            const valor = typeof value === 'number' ? value : value?.id;
            for (var i = 0; i < metodos_de_pago_abonos_bases.length; i++) {
                if (metodos_de_pago_abonos_bases[i].id == valor) {
                    return metodos_de_pago_abonos_bases[i].nombre;
                }
            }
        }
        return 'Método de pago no encontrado.';
    },
    formatear_time_lapse : value => {
        switch(value){
            case 0 : return '12 horas';
            case 1 : return '24 horas';
            case 2 : return '48 horas';
            case 3 : return '72 horas';
            case 4 : return '1 semana';
            case 5 : return '2 semanas';
        }
    },
    formatear_metodo_pago_entrada : value => {
        var metodos_pago_eventos = store.getters.getTeatro.metodos_pago_eventos_ventas;

        if (metodos_pago_eventos && metodos_pago_eventos.length > 0) {
            for (var i = 0; i <= metodos_pago_eventos.length; i++) {
                if (metodos_pago_eventos[i]) {
                    if (metodos_pago_eventos[i].id == value) {
                        return metodos_pago_eventos[i].nombre;
                    }
                } else {
                    return 'Método de pago no encontrado.'
                }
            }
        }
    },
    formatear_modalidad : value => {
        switch(value){
            case 0 : return 'ANTICIPADA';
            case 1 : return 'TAQUILLA';
        }
    },
    formatear_estado_evento : value => {
        switch(value){
            case 0 : return 'BORRADOR';
            case 1 : return 'PUBLICADO';
            case 2 : return 'CANCELADO';
        }
    },
    formatear_url : (value, params) => {
        var url = value;
        for(var i in params){
            url = url.replace(i, params[i]);
        }

        var qr_codes = params.qr_codes.join(',');
        var tid = params.tid;

        return url + '?qr_codes=' + qr_codes + '&api_key=' + localStorage.getItem('token') + '&tid=' + tid;
    },
    calcular_precio_entrada : (precio, entrada) => {
        precio = parseFloat(precio);

        if (! entrada.price_management_interno) {
            precio = precio + parseFloat(entrada.price_management);
        }

        return precio + '€';
    },
    formatear_moneda: codigo => {
        switch(codigo){
            case 978 : return '€';
            case 826 : return '£';
        } 
    },
    formatear_liquidacion_estado : value => {
        switch(value){
            case 0 : return 'Pendiente';
            case 1 : return 'En revisión';
            case 2 : return 'Liquidado';
        }
    }
}
